import React from "react";
import { getGlobal } from "./global";
export const ClientViewsContext = getGlobal(() => React.createContext({}), "ClientViewsContext");
export const ViewsProvider = ClientViewsContext.Consumer;
export const ProvideViews = ClientViewsContext.Provider;
//# sourceMappingURL=render.js.map